module.exports = __webpack_public_path__ + "img/DSC_0107.b9068824.jpg";